import * as React from "react";
const IconBitbucket = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M21.2 13.4c0 3.7 5.8 5.1 10.8 5.1s10.8-1.3 10.8-5.1-5.8-5-10.8-5-10.8 1.3-10.8 5M32 14c-2.1 0-3.8-.3-4.9-.6 1.1-.3 2.8-.6 4.9-.6s3.8.3 4.9.6c-1.1.3-2.8.6-4.9.6M32 22.4c-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4 6.4-2.9 6.4-6.4-2.9-6.4-6.4-6.4m0 8.3c-1 0-1.9-.9-1.9-1.9s.8-1.9 1.9-1.9 1.9.9 1.9 1.9-.9 1.9-1.9 1.9" />
    <path d="M51.2 5.1c-5-2.2-13.4-3.3-19.2-3.3S17.7 2.9 12.8 5.1c-1.1.5-1.8 1.6-1.6 2.8l2.5 26c.1.9.7 1.8 1.5 2.2C17.5 37.3 25.5 41 32 41c7 0 13.5-1.9 17.4-5.2.6-.5.9-1.1 1-1.9l2.5-26.1c.1-1.1-.6-2.3-1.7-2.7m-5.3 27.7c-3.1 2.3-8.4 3.7-13.9 3.7-4.9 0-11.5-2.9-14-4L15.7 8.7c4-1.4 10.7-2.5 16.3-2.5s12.2 1 16.3 2.5z" />
    <path d="M48.2 40.2c-.8-.6-1.8-.7-2.7-.3l-.3.1c-2.6 1.1-8 3.5-13.2 3.4-5.8-.1-11.2-2.5-13.5-3.5-.9-.4-2-.3-2.7.3-.8.6-1.2 1.6-1.1 2.6l1.6 14.1c.1 1 .7 1.9 1.7 2.4 3.8 1.9 8.8 3 14 3s10.2-1.1 14-3c.9-.5 1.5-1.4 1.7-2.4l1.6-14.1c.1-1-.3-2-1.1-2.6m-4.9 15.4c-3.1 1.4-7.1 2.2-11.3 2.2s-8.2-.8-11.3-2.2l-1.2-10.4c3.1 1.2 7.6 2.6 12.4 2.7 4.7.1 9.3-1.4 12.5-2.7z" />
  </svg>
);
export default IconBitbucket;
